import React from 'react';
import PrintButton from '../../../../ui-components/Button/PrintButton';
import { withStyles, StyledComponentProps } from '@material-ui/core';
import { DeleteX } from '../../../drafts/components/DeleteButton';

interface IProps extends StyledComponentProps {
    print: () => any;
    download: () => any;
    save: () => any;
    undo: () => any;
    oblivion: () => any;
}
const styles = {
    container: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '10px',
        width: '100%'
    }
}
const Comp = (props: IProps) => {
    return (<div className={props.classes.container}>

        {props.save && <>SAVE {/* <SaveButton disabled onClick={props.save} /> */}</>}
        {props.oblivion && <DeleteX action={props.oblivion} text={'Eliminazione definitiva utente. Verranno cancellate tutte le informazioni collegate e non saranno più recuperabili. Sei sicuro di voler proseguire?'} />}
        {props.print && <PrintButton onClick={props.print} />}
        {/* <DownloadButton onClick={props.print} /> */}
        {/* <CancelButton disabled onClick={props.undo} /> */}

    </div>)
}

export const Buttons = withStyles(styles)(Comp) 